declare var LtFramework: lt.Static;

const directiveName = 'ltPageDriver';
const directiveParms = 'ltPageDriverParameters';

const directive = ['navigationService', (navigationService: INavigationService) => {
	return {
		restrict: 'A',
		priority: -10000,
		link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
			const key: string = attributes[directiveName];
			const paramsVal: string = attributes[directiveParms];
			let params: {
				[key: string]: string
			} = {};

			if (element[0].nodeName !== 'A') {
				return;
			}

			if (paramsVal) {
				params = scope.$eval(paramsVal);
			}

			let url = navigationService.resolveDestination(key, params);

			if (!url) {
				// tslint:disable-next-line: no-console
				console.error(`Page Driver ${key} does not exist.`);
				return;
			}

			// if a page anchor was on original href, append it to url
			const href = element.attr('href');
			if (href.indexOf('#') >= 0 && href.length - 1 > href.indexOf('#')) {
				url += href.substr(href.indexOf('#'));
			}

			element.attr('href', url);
		}
	};
}];

export default function(module: ng.IModule): void {
	module.directive(directiveName, directive);
}
